import { TTintColor } from '../types';

type TProps = {
  tintServiceLabel: string;
  activeTintColor: TTintColor | null;
  countOfSelectedColors: number;
  noTintLabel: string;
  isTintServicePriceLoading: boolean;
};

export const getTintLabel = ({
  tintServiceLabel,
  activeTintColor,
  countOfSelectedColors,
  noTintLabel,
  isTintServicePriceLoading,
}: TProps) => {
  let labelToDisplay = '';

  if (activeTintColor !== null) {
    labelToDisplay = isTintServicePriceLoading ? '' : tintServiceLabel;

    const { COLOR_NAME, COLLECTION_NAME } = activeTintColor;

    const collectionLabel = COLLECTION_NAME !== undefined ? ` ${COLLECTION_NAME}` : '';

    return `${labelToDisplay}${collectionLabel} ${COLOR_NAME}`;
  }

  if (countOfSelectedColors > 0) {
    return `${labelToDisplay} ${noTintLabel}`.trim();
  }

  return `${labelToDisplay}`;
};
